<div class="active-filter-section-container">
  <div class="active-filter-section">
    <div class="active-filter-status">
      <div class="active-filter-label">
        Active filter: <strong>{{ filterService.activeFilterName() }}</strong> (<a [href]="null" class="active-filter-btn" (click)="changeFilter($event)">Change</a>)
      </div>
      <div class="active-filter-links">
        <a href="https://discord.gg/JbaMnwngvq" target="_blank" rel="noopener noreferrer" class="active-filter-link no-icon" title="Discord">
          <span class="icon icon-discord"></span>
        </a>
        <span class="active-filter-sep"></span>
        <a href="https://www.pathofexile.com/forum/view-thread/3630063" target="_blank" rel="noopener noreferrer" class="active-filter-link no-icon" title="Official Forum">
          <span class="icon icon-ggg-logo-horizontal"></span>
        </a>
        <span class="active-filter-sep"></span>
        <a href="https://patreon.com/poe2filter" target="_blank" rel="noopener noreferrer" class="active-filter-link no-icon" title="Become a patron">
          <span class="icon icon-patreon-icon"></span>
        </a>
        <span class="active-filter-sep"></span>
        <a href="https://buymeacoffee.com/poe2filter" target="_blank" rel="noopener noreferrer" class="active-filter-link no-icon" title="Buy me a coffee">
          <span class="icon icon-buymeacoffee"></span>
        </a>
      </div>
    </div>
  </div>
</div>

@if (showFilterSelectorDialog) {
  <div class="search-bar" style="padding: 0px !important;">
    <app-filter-selector-dialog
      (close)="showFilterSelectorDialog = false">
    </app-filter-selector-dialog>
  </div>
}
